import { render } from "./BottomTip.vue?vue&type=template&id=ce6d0002&scoped=true"
import script from "./BottomTip.vue?vue&type=script&lang=js"
export * from "./BottomTip.vue?vue&type=script&lang=js"

import "./BottomTip.vue?vue&type=style&index=0&id=ce6d0002&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce6d0002"]])

export default __exports__